import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER, LOCALE_ID } from '@angular/core';
import { MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatSnackBarModule, MatButtonModule, MatProgressSpinner, MatProgressSpinnerModule, MatCardModule, MatDatepickerModule, MatFormFieldModule, MatInputModule, MatRadioModule, MatDividerModule, MatDialogModule } from '@angular/material';
import { BASE_PATH, DemandeSimulationResourceService, RecaptchaValidationResourceService } from '@com.sofaxis/sofaxis-fonpel-simulation-ws-ts';
import { HttpClientModule } from '@angular/common/http';
import localeFr from '@angular/common/locales/fr';
import { MatIconModule } from '@angular/material/icon';
import { registerLocaleData, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SnackErrorComponent } from './shared/components/snack-error/snack-error.component';
import { SnackWaitComponent } from './shared/components/snack-wait/snack-wait.component';
import { SnackSuccessComponent } from './shared/components/snack-success/snack-success.component';
import { SharedModule } from './shared/shared.module';
import { AppConfig } from './utils/app.config';
import { HttpModule } from '@angular/http';
import { QuitConfirmDialogComponent } from './shared/components/quit-confirm-dialog/quit-confirm-dialog.component';
import { ConfirmDialogComponent } from './shared/components/confirm-dialog/confirm-dialog.component';
import { MatMomentDateModule, MAT_MOMENT_DATE_FORMATS } from '@angular/material-moment-adapter';
import { WarningDialogComponent } from "./shared/components/warning-dialog/warning-dialog.component";
import { InfoDialogComponent } from "./shared/components/info-dialog/info-dialog.component";
import { GlobalLoadingService } from "./api/global-loading.service";
import { DirectivesModule } from "src/app/directives/directives.module";
import { FlexLayoutModule } from "@angular/flex-layout";
import { CacheService } from "./api/cache.service";
import { ReactiveFormsModule } from "@angular/forms";
import { PipesModuleModule } from "./pipes/pipes-module.module";
import { ErrorDialogComponent } from "src/app/shared/components/error-dialog/error-dialog.component";
import { STEPPER_GLOBAL_OPTIONS } from "@angular/cdk/stepper";
import { DecimalHelperService } from "src/app/api/decimal-helper.service";
import { UpperCasePipe } from "@angular/common";
import { APP_BASE_HREF } from "@angular/common";

export const MY_FORMATS = {
    parse: {
        dateInput: 'DD/MM/YYYY',
    },
    display: {
        dateInput: 'DD/MM/YYYY',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
    },
};

registerLocaleData( localeFr );

export function initConfig( config: AppConfig ) {
    return () => config.load();
}

@NgModule( {
    declarations: [
        AppComponent
    ],
    imports: [
        HttpClientModule,
        HttpModule,
        BrowserModule,
        AppRoutingModule,
        SharedModule,
        BrowserAnimationsModule,
        FlexLayoutModule,
        MatDividerModule,
        MatIconModule,

        MatCardModule,
        MatDatepickerModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatSnackBarModule,
        DirectivesModule,
        MatRadioModule,
        MatProgressSpinnerModule,
        MatMomentDateModule,
        MatButtonModule,
        FormsModule,
        PipesModuleModule

    ],

    providers: [
        { provide: MAT_DATE_LOCALE, useValue: 'fr-FR' },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
        { provide: LOCALE_ID, useValue: 'fr-FR' },
        {
            provide: STEPPER_GLOBAL_OPTIONS,
            useValue: { showError: true }
        },
        AppConfig,
        {
            provide: APP_INITIALIZER,
            useFactory: initConfig,
            deps: [AppConfig],
            multi: true
        },
        { provide: APP_BASE_HREF, useValue: '/demandesimulation' },
        { provide: BASE_PATH, useExisting: APP_BASE_HREF },
        DatePipe,
        DecimalHelperService,
        GlobalLoadingService,
        CacheService,
        UpperCasePipe,
        DemandeSimulationResourceService,
        RecaptchaValidationResourceService
    ],
    entryComponents: [SnackErrorComponent, SnackWaitComponent, SnackSuccessComponent, QuitConfirmDialogComponent, ConfirmDialogComponent, WarningDialogComponent, ErrorDialogComponent, InfoDialogComponent],
    bootstrap: [AppComponent]
} )
export class AppModule { }
